import React from "react";
import "./Table.css";
import { ReactComponent as CircularLoader } from "../../assets/svg/CircularLoader.svg";

function Table({
  data,
  columns,
  keyExtractor,
  onRowClick,
  isLoading = false,
  emptyState,
  className = "",
  sortColumn,
  sortDirection,
  onSort,
}) {
  const handleHeaderClick = (column) => {
    if (column.sortable && onSort) {
      onSort(column.key);
    }
  };

  const renderSortIcon = (column) => {
    if (!column.sortable) return null;

    if (sortColumn === column.key) {
      return (
        <span className="sort-icon">
          {sortDirection === "asc" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="18 15 12 9 6 15"></polyline>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          )}
        </span>
      );
    }

    return (
      <span className="sort-icon sort-icon-inactive">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <polyline points="19 12 12 19 5 12"></polyline>
        </svg>
      </span>
    );
  };

  if (isLoading) {
    return (
      <div className={`table-container ${className}`}>
        <div className="table-loading">
            <div className='fetching_loader'><CircularLoader /></div>
        </div>
      </div>
    );
  }

  if (data.length === 0 && emptyState) {
    return (
      <div className={`table-container ${className}`}>
        <div className="table-empty-state">{emptyState}</div>
      </div>
    );
  }

  return (
    <div className={`table-container ${className}`}>
      <table className="table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                style={{ width: column.width }}
                className={column.sortable ? "sortable" : ""}
                onClick={() => handleHeaderClick(column)}
              >
                <div className="th-content">
                  {column.header}
                  {renderSortIcon(column)}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={keyExtractor(item, index)}
              onClick={onRowClick ? () => onRowClick(item, index) : undefined}
              className={onRowClick ? "clickable" : ""}
            >
              {columns.map((column) => (
                <td key={`${keyExtractor(item, index)}-${column.key}`}>
                  {column.cell(item, index)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
